import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { CompositionImage, ProductImage, ProductTypeImage, getCardImageSrc } from './sprdImageUtils';
export type SprdResponsiveImageData = (ProductTypeImage | ProductImage | CompositionImage) & {
  loading?: 'lazy' | 'eager';
  priority?: 'high' | 'low' | 'auto';
  alt: string;
};
export type SprdResponsiveImageProps = {
  className?: string;
  imageBaseUrl: string;
  image: SprdResponsiveImageData;
  defaultImageWidth?: number;
  defaultImageHeight?: number;
};
export const SprdResponsiveImage = t0 => {
  const $ = _c(13);
  const {
    className,
    imageBaseUrl,
    image,
    defaultImageWidth: t1,
    defaultImageHeight: t2
  } = t0;
  const defaultImageWidth = t1 === undefined ? 450 : t1;
  const defaultImageHeight = t2 === undefined ? 600 : t2;
  let t3;
  if ($[0] !== defaultImageHeight || $[1] !== defaultImageWidth || $[2] !== image || $[3] !== imageBaseUrl) {
    t3 = getCardImageSrc(imageBaseUrl, image, defaultImageWidth, defaultImageHeight);
    $[0] = defaultImageHeight;
    $[1] = defaultImageWidth;
    $[2] = image;
    $[3] = imageBaseUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const defaultImageSrc = t3;
  const t4 = image.alt;
  const t5 = image.loading ?? "lazy";
  const t6 = image.priority;
  let t7;
  if ($[5] !== className) {
    t7 = clsx("size-full object-cover text-transparent", className);
    $[5] = className;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== defaultImageSrc || $[8] !== image.alt || $[9] !== image.priority || $[10] !== t5 || $[11] !== t7) {
    t8 = <img alt={t4} src={defaultImageSrc} decoding="async" loading={t5} fetchPriority={t6} className={t7} />;
    $[7] = defaultImageSrc;
    $[8] = image.alt;
    $[9] = image.priority;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};